// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WF3ki","col":"styles_col__1wqAT"};